import { render } from "./TelephoneIcon.vue?vue&type=template&id=58ae87f9"
import script from "./TelephoneIcon.vue?vue&type=script&lang=js"
export * from "./TelephoneIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__